<template>
  <div class="partner-page-view">
    <div class="nav-page-box">
      <nav-page-view
        :tabHoverPage="3"
      ></nav-page-view>
    </div>
    <div class="partner-banner">
      <img :src="partnerBanner" alt="">
      <div>
        <banner-page-view
          :titleObj="partnerBannerObj"
        ></banner-page-view>
      </div>
    </div>
    <div class="partner-center-box">
      <div class="partner-center flex-middle-x layout-flex-justify-content_space-between">
        <div class="partner-content flex-middle-x layout-flex-justify-content_space-between">
          <img :src="partnerCenterTitleImage" alt="">
          <div>
            <h4>定制化服务</h4>
            <p>系统开发及实施服务快速上线，整合各合作平台后台逻辑、数据库工程及前
              端整体页面设计框架均已经有成熟模型，可以根据客户实际需求修正定制，
              仅需提供标准接口及接入机制，整体上线周期控制在50天。并且提供系统
              层面24小时技术支持，专人负责；同时提供灾备功能及订单回传功能，实
              现整套订单数据信息的卡中心共享，为客户后期数据分析及挖掘提供维度支持
              我们见识到了这支创业团队的专业度和专注产品打磨的匠人精神。
            </p>
          </div>
        </div>
        <div>
          <img :src="partnerCenterImage" alt="">
        </div>
      </div>
    </div>
    <div class="symbiosis">
      <title-page-view
        :titleObj="symbiosisObj"
      ></title-page-view>
    </div>
    <ul class="flex-middle-x">
      <li v-for="(item,index) in symbiosisList">
        <img :src="item.image" alt="">
      </li>
    </ul>
    <div class="footer-page-box">
      <footer-page-view
      ></footer-page-view>
    </div>
  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {
        partnerBanner: require('./image/partner-banner.jpg'),
        partnerCenterTitleImage:require('./image/partner-center-title-image.png'),
        partnerCenterImage:require('./image/product-center-image.jpg'),
        partnerBannerObj:{
          mainHeading:'合作伙伴',
          subhead:'力致打造行业领导者',
          content:'Shanghai golden guarantee network technology co. LTD'
        },
        symbiosisObj:{
          mainHeading:'Part of the case',
          subhead:'合作伙伴',
          content:'“按需求定制最优框架，提供简单易用操作体验，交付满意服务成果”'
        }
      }
    },
    computed:{
      symbiosisList(){
        return [
          {image:require('./image/pufa.png')},
          {image:require('./image/jtyh.png')},
          {image:require('./image/icbc.png')},
          {image:require('./image/pa.png')},
          {image:require('./image/hx.png')},
          {image:require('./image/ms.png')},
          {image:require('./image/gd.png')},
          {image:require('./image/sh.png')},
          {image:require('./image/bj.png')},
          {image:require('./image/zh.png')},
          {image:require('./image/abc.png')},
          {image:require('./image/jh.png')}
        ]
      }
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">
  .partner-page-view{
    .partner-banner{
      width:100%;
      min-width:1200px;
      position: relative;
      height:450px;
      overflow: hidden;
      img{
        width:100%;
        min-height:450px;
      }
      div{
        width:600px;
        position: absolute;
        top:50%;left:50%;
        transform: translate(-50%, -50%);
      }
    }
    .partner-center-box{
      width:100%;
      background: $color-4;
      padding-top:40px;
      .partner-center{
        width:1200px;
        margin:auto;
        .partner-content{
          img{
            width:80px;
          }
          div{
            text-align: left;
            margin-left:40px;
            h4{
              font-size:20px;
              color:$color-black;
            }
            p{
              font-size:16px;
              color:$color-3;
              margin-top:10px;
              line-height:30px;
            }
          }
        }
        img{
          width:500px;
          margin-left:25px;
        }
      }
    }
    ul{
      width:1200px;
      margin:auto;
      flex-wrap: wrap;
      margin-top:50px;
      padding-bottom:200px;
      li{
        width:365px;
        margin-left:10px;
        margin-top:5px;
        img{
          width:100%;
        }
      }
    }
    .footer-page-box{
      width:100%;
    }
  }
</style>
